import type React from 'react';

import { AmbassadorsPageContextProvider } from '#src/app/pages/ambassadors/landing/pageContext';

import { Layout } from '../layout';

export const Ambassadors: React.FC<EmptyProps> = () => {
	return (
		<AmbassadorsPageContextProvider>
			<Layout />
		</AmbassadorsPageContextProvider>
	);
};
